module.exports = __webpack_public_path__ + "static/screenshot2-81bad60d93e2183768b2b9cb52ff8534.png";